export default "__VITE_ASSET__BwwY3Orx__"